<template>
  <div style="margin-top:-10px !important">
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <b-row
        class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
        style="height:42px"
      >
        <!-- <b-col m5="1"></b-col> -->
        <b-col cols="4" md="4" xl="4" lg="4" sm="4" xs="4" class="text-left px-0">
          <!--  invoice header details -->

          <!--  invoice no and status name -->
          <h2 class="custom-page-title mb-2 mt-1">{{ list.data.header_details.pymnt_no}}</h2>
        </b-col>
        <b-col cols="8" md="8" xl="8" lg="8" sm="8" xs="8" class="text-right px-0">
        
               <b-button variant="success" size="sm" class="mr-2" @click="recordrefund()"  v-if="parseFloat(list.data.header_details.excess_amount) > 0 && RoutePermission(false,'','invoice','paymentsreceived','create')">Refund</b-button>

        
          <b-button variant="primary" 
        size="sm"
        class="mr-2" 
      v-if="RoutePermission(false,'','','paymentsreceived','create')"
        :to="{ name: 'PaymentCreate', query:{page_from:'view',old_id:$route.params.id}}">
        New Payment
        </b-button>

          <b-button-group variant="light">
            <b-button
              size="sm"
              v-if="RoutePermission(false,'','invoice','paymentsreceived','update')"
              :to="{ name : 'PaymentUpdate',params:{id:$route.params.id},query:{page_from:'view'}}"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>
            <b-button
              variant="light"
              size="sm"
              title="email"
              v-if="RoutePermission(false, '', 'invoice', 'paymentsreceived', 'email')"
              @click="emailstatement()"
            >
            
                <i class="la la-envelope-o la-lg"></i>
            </b-button>
            <b-button
              variant="light"
              size="sm"
              title="delete"
              v-if="parseFloat(list.data.header_details.refund_amount) == 0 && (list.data.header_details.pymnt_type == 1 || (list.data.header_details.pymnt_type == 2 && parseFloat(list.data.header_details.used_amount) == 0)) && RoutePermission(false,'','invoice','paymentsreceived','delete')"
              @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this payment?',
                  title : 'Delete Payment - '+list.data.header_details.pymnt_no,
                  module:'payment/deletepayment',
                  data:JSON.stringify({
                    id : $route.params.id
                  }),
                  RoutePlace:'Payment',
                  isRoute:'true',
                  type: 'delete',
                  route_history: payment_index_history,
                })"
            >
              <i class="glyphicon glyphicon-trash"></i>
            </b-button>
            <b-button variant="light" size="sm" title=" print" @click="handlePrint()">
              <i class="la la-print la-lg"></i>
            </b-button>

            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="payment_index_history ? payment_index_history : { name: 'Payment' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
            <!-- <a title=" print" id="print_url" size="sm" href="#" class="btn btn-light"></a> -->
          </b-button-group>
          <!-- <a title=" attach" href="#" class="btn btn-light" @click="$router.go(-1)">
            <i class="la la-remove la-lg text-decoration-none"></i>
          </a>-->
        </b-col>
      </b-row>
      <!-- 
      page first block
      -->
      <div class="view-block-tab" style="margin-left:-20px;margin-right:-20px;">
        <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-2 border-tab">
          <!--  payment amount used in invoice tabs -->
          <b-tab
            title="Payment Received View"
            :title-link-class="{'d-print-none':true}"
            class="p-0"
          >
            <div class="view-block d-flex d-print-none mb-4" :show="true">
              <b-row class="w-100">
                <b-col cols="12" lg="12" md="12" class="py-3 d-flex px-2">
                  <div class="d-flex ml-3">
                    <div class="verticalLine5 pl-3 ml-4">
                      <h6>Received Amount</h6>

                      <span>{{getDetails( $AppDetails.currency_details,list.data.header_details.cus_currency,"currency_symbol")  +" "+ parseFloat(list.data.header_details.received_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                    <div class="verticalLine4 pl-3 ml-5">
                      <h6>Available Amount</h6>

                      <span>{{getDetails($AppDetails.currency_details,list.data.header_details.cus_currency,"currency_symbol")  +" "+ parseFloat(list.data.header_details.excess_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                    <div class="verticalLine3 pl-3 ml-5">
                      <h6>Used Amount</h6>

                      <span>{{getDetails($AppDetails.currency_details,list.data.header_details.cus_currency,"currency_symbol")  +" "+ parseFloat(list.data.header_details.used_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                    <div class="verticalLine5 pl-3 ml-5">
                      <h6>Refund Amount</h6>

                      <span>{{getDetails($AppDetails.currency_details,list.data.header_details.cus_currency,"currency_symbol") +" "+ parseFloat(list.data.header_details.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <StandardPrint
              class="custom-md-width"
              :list="list"
              v-if="pymnt_settings_details.print.templateId == 21"
            ></StandardPrint>
            <RetailPrint
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              class="custom-md-width mb-5"
              :list="list"
              v-if="pymnt_settings_details.print.templateId == 28"
            ></RetailPrint>
            <div class="p-4">
            <h4>More Information</h4>
            <div class="d-flex py-2">
              <div class="fw-semi-bold">Customer Notes <span class="px-2">:</span> </div>
              <div style="word-break:break-word;white-space:pre">{{list.data.header_details.notes}}</div>
            </div>
            </div>
            
          </b-tab>

          <b-tab
            :title="'Payments ('+list.data.invoice_details_payment.length+')'"
            :title-link-class="{'d-print-none':true}"
            v-if="list.data.invoice_details_payment.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-left"
                        width="20%"
                        style="padding-left:22px !important"
                      >Invoice Number</th>
                      <th>Invoice Date</th>
                      <th class="text-right">Invoice Amount</th>
                      <th class="text-right">Payment Amount</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,index)  in list.data.invoice_details_payment"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td class="text-left" width="20%" style="padding-left:22px !important">
                        <router-link
                          v-if="RoutePermission(false,'','invoice','invoice','index')"
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id }}"
                        >{{item.inv_no }}</router-link>
                        <template v-else>{{item.inv_no }}</template>
                      </td>
                      <td>{{ getDateFormat(item.created_date) }}</td>
                      <td
                        class="text-right"
                      >{{ cus_currency_symbol +" "+ parseFloat(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td
                        class="text-right"
                      >{{ cus_currency_symbol +" "+ parseFloat(item.pymnt_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td width="50px" style="width:50px;padding-right:22px !important">
                        <span v-show="showByIndex === index">
                          <i
                            class="glyphicon glyphicon-trash"
                            @click="deletepaymentreason(index)"
                            v-if="RoutePermission(false,'','invoice','paymentsreceived','delete')"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
          <!--  payment amount refunded details -->
          <b-tab
            :title="'Refund ('+list.data.refund_payment_details.length+')'"
            :title-link-class="{'d-print-none':true}"
            v-if="list.data.refund_payment_details.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th class="text-left" width="20%" style="padding-left:22px !important">Date</th>
                      <th>Payment Mode</th>
                      <th class="text-right">Amount Refunded</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,index) in list.data.refund_payment_details"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td
                        class="text-left"
                        width="20%"
                        style="padding-left:22px !important"
                      >{{ getDateFormat(item.pymnt_applied_date) }}</td>
                      <td>{{item.method_name}}</td>
                      <td
                        class="text-right"
                      >{{ cus_currency_symbol +" "+ parseFloat(item.pymnt_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td width="50px" style="padding-right:22px !important">
                        <span v-show="showByIndex === index">
                          <i
                            class="glyphicon glyphicon-trash"
                            @click="deleterefund(index)"
                            v-if="RoutePermission(false,'','invoice','paymentsreceived','delete')"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
      <DeletePaymentRecord
        v-on:setAmountDetails="updateAmountDetails($event)"
        :PaymentDeleteDetail="PaymentDeleteDetail"
        @recallRecord="recallRecord()"
      ></DeletePaymentRecord>
      <DeleteRefundRecord
        v-on:setRefundAmountDetails="updateRefundAmountDetails($event)"
        :RefundDeleteDetail="RefundDeleteDetail"
        page="payment"
        @recallRecord="recallRecord()"
      ></DeleteRefundRecord>
      <!--  paymetn delete modal -->
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :route_history="route_history"
        :type="globalmodaltype"
      />
    </template>
  </div>
</template>

<script>
import getPageTitle from "@/utils/get-page-title"; // to set page title
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import DeletePaymentRecord from "@/components/Modal/InvoiceModal/DeletePaymentRecord"; // modal for deleting created credit used record
import DeleteRefundRecord from "@/components/Modal/InvoiceModal/DeleteRefundRecord"; // modal for deleting created credit used record
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import $ from "jquery";
import store from "@/store/index";
import Widget from "@/components/Widget/Widget";
import { number_to_words } from "@/mixins/NumberToWords";
import RecordNotFound from "@/pages/Error/RecordNotFound";
import StandardPrint from "@/components/Form/PaymentsReceived/Print/Standard";
import RetailPrint from "@/components/Form/PaymentsReceived/Print/Retail";
export default {
  name: "PaymentView",
  mixins: [notificationMixin],
  data() {
    return {
      showprintlabel: false,
      printlabel: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      showByIndex: null,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      cus_currency_symbol: this.orgCurrencySymbol,
      total_in_words: "",
      show_notes: false,
      PaymentDeleteDetail: {},
      deletedpymntrecord: "", // to remove the item from the view page
      RefundDeleteDetail: {},
      deletedrefundrecord: "", // to remove the item from the view page
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      field: {}
    };
  },
  components: {
    DeletePaymentRecord,
    Widget,
    DeleteRefundRecord,
    RecordNotFound,
    StandardPrint,
    RetailPrint
  },
  methods: {
    recallRecord(){
      store.dispatch("payment/fetchviewList", parseInt(this.$route.params.id));
    },
    getTempProps() {
      
      this.field = this.$store.state.permission.print_settings_details[
        "Payments Received"
      ].template_list;
    },
     async emailstatement(){
       await store.dispatch("payment/fetchviewList", parseInt(this.$route.params.id))
      if(this.status_code==200){
        this.$router.push({
          name: "Email",
          query: {tns_type:'Payment Received',tns_date: this.list.data.header_details.pymnt_date,cus_id:this.list.data.header_details.cus_id,cus_name:this.list.data.header_details.cus_name,
                tns_no:this.list.data.header_details.pymnt_no,
                tns_mail:this.list.data.header_details.cus_mail,
                tns_currency:this.list.data.header_details.cus_currency,
                id:this.$route.params.id,date_format:this.org_details.date_format  }
        });
      }
    },
    async handlePrint() {
    await  store.dispatch("payment/fetchviewList", parseInt(this.$route.params.id))
      
       if(this.status_code==200){
         await this.getTempProps();
      document.title =
        this.list.data.header_details.pymnt_no +
        " / " +
        this.getDateFormat(this.list.data.header_details.pymnt_date);
      var id;
      var style;  
      var size;
      if (
        this.pymnt_settings_details.print.templateId == 21 ||
        this.pymnt_settings_details.print.templateId == 28
      ) {
        id =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "a4-standard-portrait-page"
              : "a4-standard-landscape-page"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "a5-standard-portrait-page"
              : "a5-standard-landscape-page"
            : "";
        style = "standard";
        size =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "size:A4;"
              : "size:A4 landscape;"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "size:A5;"
              : "size:A5 landscape;"
            : "";
      }
      // else if (this.pymnt_settings_details.print.templateId == 21) {
      //   id =
      //     this.field.temp_prop.paper_size == 0
      //       ? this.field.temp_prop.orientation == 0
      //         ? "a4-spreadsheet-portrait-page"
      //         : "a4-spreadsheet-landscape-page"
      //       : this.field.temp_prop.paper_size == 1
      //       ? this.field.temp_prop.orientation == 0
      //         ? "a5-spreadsheet-portrait-page"
      //         : "a5-spreadsheet-landscape-page"
      //       : "";
      //   size =
      //     this.field.temp_prop.paper_size == 0
      //       ? this.field.temp_prop.orientation == 0
      //         ? "size:A4;"
      //         : "size:A4 landscape;"
      //       : this.field.temp_prop.paper_size == 1
      //       ? this.field.temp_prop.orientation == 0
      //         ? "size:A5;"
      //         : "size:A5 landscape;"
      //       : "";
      //   style = "spreadsheet";
      // } else {
      //   id =
      //     this.field.temp_prop.paper_size == 0
      //       ? "inch3-thermal-print-page"
      //       : "inch4-thermal-print-page";
      //   style = "retail";
      //   size = "";
      // }
      var win;
      const element = document.getElementById(id);
      var printcontent = "";
      if (this.pymnt_settings_details.print.templateId == 28) {
        for (var i = 1; i <= 2; i++) {
          this.showprintlabel = await true;
          this.printlabel = await (i == 1 ? "CUSTOMER COPY" : "MERCHANT COPY");
          printcontent +=
            (await ' <div style="page-break-after:always">') +
            element.innerHTML +
            "</div>";
        }
      } else {
        printcontent +=
          (await ' <div style="page-break-after:always">') +
          element.innerHTML +
          "</div>";
      }

      win = window.open(
        "",
        "Title",
        "fullscreen=yes",
        "titlebar=yes",
        "scrollbars=yes"
      );
      win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${process.env.VUE_APP_INVOICE_API_URL}/css/print/${style}.css">
              </head>
              <body class="${id}">
              ${printcontent}
              </body>
            </html>
          `);
      setTimeout(() => {
        win.document.close();
        this.printlabel = "";
        this.showprintlabel = false;
        win.focus();
        win.print();
        win.close();
      }, 1000);
       }
    },
    // delete the selected recorc credti applied
    deleterefund(index) {
      this.$root.$emit("bv::show::modal", "deleterefundpayment");
      this.RefundDeleteDetail = this.list.data.refund_payment_details[index];
      this.deletedrefundrecord = index;
    },
     async recordrefund(){
       await this.recallRecord();
        if(this.status_code!=404){
          this.$router.push({
            name : 'PaymentRefund',
            params:{id:this.$route.params.id},
            query:{page:'pymnt_receive'}
          })
        }
    },

    // get the reason how to delete the payment
    deletepaymentreason(index) {
      this.submitted = true;
      this.list.data.invoice_details_payment[index].inv_pymnt_id;

      store
        .dispatch(
          "invoice/deletepaymentreason",
          JSON.stringify({
            id: this.list.data.invoice_details_payment[index].inv_pymnt_id
          })
        )
       .then(response => {

          if(response.code==200){
         this.submitted = false;
          this.$root.$emit("bv::show::modal", "paymentreason");

          this.PaymentDeleteDetail = this.list.data.invoice_details_payment[
            index
          ];
          this.deletedpymntrecord = index;
          }else{
            window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
             message: response.status,
            type: response.type,
            showCloseButton: true,
          });
          this.recallRecord()
          }
          // this.$refs["paymentreason"].show();
        });
    },
    //  delete payment
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    updateAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.data.header_details.used_amount =
        parseFloat(this.list.data.header_details.used_amount) -
        parseFloat(event.PaymentDeleteDetail.pymnt_applied_amount);
      // add applied amount to available amount
      this.list.data.header_details.excess_amount =
        parseFloat(this.list.data.header_details.excess_amount) +
        parseFloat(event.PaymentDeleteDetail.pymnt_applied_amount);
      //  remove the record from list
      this.list.data.invoice_details_payment.splice(this.deletedpymntrecord, 1);
      if (this.list.data.invoice_details_payment.length == 0) {
        this.$router.push({
          name: "Payment"
        });
      }
    },
    updateRefundAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.data.header_details.refund_amount =
        parseFloat(this.list.data.header_details.refund_amount) -
        parseFloat(event.RefundDeleteDetail.pymnt_applied_amount);
      // add applied amount to available amount
      this.list.data.header_details.excess_amount =
        parseFloat(this.list.data.header_details.excess_amount) +
        parseFloat(event.RefundDeleteDetail.pymnt_applied_amount);
      //  remove the record from list
      this.list.data.refund_payment_details.splice(this.deletedrefundrecord, 1);
    }
  },
  created() {
    this.getTempProps();
    this.cus_currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.data.header_details.cus_currency,
      "currency_symbol"
    );
    document.title = getPageTitle(
      this.list.data.header_details.pymnt_no + " | " + this.$route.meta.title
    );
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.data.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(
        this.list.data.header_details.received_amount,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.data.header_details.cus_currency,
          "currency_code_fraction"
        )
      );

    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      list: state => state.payment.list,
      status_code: state => state.payment.status_code,
      status_message: state => state.payment.status_message,
      status_type: state => state.payment.status_type,
      payment_index_history: state => state.payment.payment_index_history
    }),
    ...mapGetters([
      "org_details",
      "pymnt_settings_details",
      "orgCurrencySymbol",
      "general_settings_details"
    ])
  }
};
</script>
<style scoped>
.vr {
  border-right: thick solid rgb(190, 184, 184);
  border-width: 1px;
  height: 10px;
  margin-right: 6px;
}
</style>
